import { render } from "./dropdown.vue?vue&type=template&id=4a24f3fd"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__